document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });
    //slider 2 images
    let slider2Images = new Swiper('.swiper-img-slider', {
        loop: true,
        speed: 700,
        spaceBetween:10,
        slidesPerView:"auto",
        allowTouchMove: false,
        centeredSlides: true,
        navigation: {
            nextEl: ".slider-block_arrows .arrow-next",
            prevEl: ".slider-block_arrows .arrow-prev",
          },
          breakpoints: {
            600: {
                spaceBetween: 30,
                centeredSlides: false,
            },
          }
    });
    let slider2Copy = new Swiper('.swiper-copy-slider', {
        loop: true,
        speed: 700,
        slidesPerView:1,
        effect: 'fade',
        allowTouchMove: false,
        autoHeight: true,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".slider-block_arrows .arrow-next",
            prevEl: ".slider-block_arrows .arrow-prev",
        },
        breakpoints: {
        600: {
            autoHeight: false,
        },
        }
       
    });

    if(document.querySelectorAll('.js-swiper-arrow').length > 0){
        let indexPagination = 0;
        document.querySelectorAll('.js-swiper-arrow').forEach((arrow) => {
            arrow.addEventListener('click', () => {
                
                let arrowLimit = parseInt(arrow.getAttribute('data-limit'));
                if(arrow.classList.contains('prev')) {
                    indexPagination = indexPagination == 0 ? arrowLimit : indexPagination - 1;
                } else {
                    indexPagination = indexPagination == arrowLimit ? 0 : indexPagination + 1;

                }
                let prevItem = indexPagination == 0 ? arrowLimit : indexPagination - 1;
                let nextItem = indexPagination == arrowLimit ? 0 : indexPagination + 1;
                document.querySelectorAll('.js-arrow-pagination').forEach((pagination,i) => {pagination.classList.add('hidden');});
                document.querySelectorAll('.js-arrow-pagination')[prevItem].classList.remove('hidden');
                document.querySelectorAll('.js-arrow-pagination')[nextItem].classList.remove('hidden');
                
            })
        })
    }
     let sliderEvents = new Swiper('.events-swiper', {
        loop: true,
        speed: 700,
        slidesPerView:'auto',
        navigation: {
            nextEl: ".featured-event .arrow-next",
            prevEl: ".featured-event .arrow-prev",
        },
    });
});